import {useState} from "react"
import { Container, Row, Col, Card } from "react-bootstrap";
import FormMonthlyReport from "./components/FormMonthlyReport.jsx"
import Textfield from "../../common/components/Textfiled.jsx"
import {useMonthlyReportCommand} from "./hooks/useMonthlyReportCommand.js"
import {useMonthlyReportsQuery} from "./hooks/useMonthlyReportsQuery.js"
import { DateUtil } from "../../common/utils/date.util.js";

function MonthlyReport(){
  const [filters, setFilters] = useState({startDate: "", endDate: ""})
  const {monthlyReports, refresh} = useMonthlyReportsQuery(filters)
    const {monthlyReport, handleChange, errors: {errors}, createMonthlyReport} = useMonthlyReportCommand(refresh)

const handleSubmit = () => {
    createMonthlyReport();
  }

  const handleChangeFilters =  ({ name, value }) => {
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

    return(
    <main>
  <Container>
    {/* Formulario */}
    <section className="mb-5">
      <Card>
        <Card.Header>
          <h2 className="h5 mb-0">Registro informe mensual</h2>
        </Card.Header>
        <Card.Body>
          <FormMonthlyReport
            monthlyReport={monthlyReport}
            errors={errors}
            onChange={handleChange}
            onSubmit={handleSubmit}
          />
        </Card.Body>
      </Card>
    </section>

    {/* Filtros e informes */}
    <section className="d-flex flex-column mb-5">
      <h2 className="mb-4">Informes mensuales</h2>

      {/* Filtros */}
      <Row className="mb-4">
        <Col md={6}>
          <Textfield
            label="Fecha de inicio"
            type="date"
            name="startDate"
            value={filters.startDate}
            onChange={handleChangeFilters}
          />
        </Col>
        <Col md={6}>
          <Textfield
            label="Fecha de fin"
            type="date"
            name="endDate"
            value={filters.endDate}
            onChange={handleChangeFilters}
          />
        </Col>
      </Row>

      {/* Lista de reportes */}
        
<Row>
  {monthlyReports.map((report) => (
    <Col md={6} lg={4} key={report.id} className="mb-3">
      <Card>
        <Card.Body>
          <Card.Title>{DateUtil.format(report.date)}</Card.Title>
          <Card.Text>{report.observations}</Card.Text>

          {report.file && (
            <a
              href={report.file}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary btn-sm"
            >
              Ver archivo
            </a>
          )}
        </Card.Body>
      </Card>
    </Col>
  ))}
</Row>
    </section>
  </Container>
</main>    )
  }

  export default MonthlyReport;
